
























import { Component, Vue } from "vue-property-decorator";
import Card from "@/components/Card.vue";

import { TweenMax, TimelineMax, Power1 } from "gsap/all";
import ScrollMagic from 'scrollmagic';
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";

@Component({
  components: {
    Card,
  }
})
export default class StatsSection extends Vue {
  controller: any = null;
  scenes: any = [];

  data() {
    return {
      cardData: [
        {
          additionalClass: "",
          cardHeading: "67%",
          cardDescription: "increase in booking rate",
        },
        {
          additionalClass: "",
          cardHeading: "10x",
          cardDescription: "longer engagement",
        },
        {
          additionalClass: "highlight",
          cardHeading: "75%",
          cardDescription: "public wants virtual tour",
        },
        {
          additionalClass: "",
          cardHeading: "4 weeks",
          cardDescription: "to recoup ROI",
        }
      ]
    }
  }

  mounted() {
    this.scenes = []; 
    this.cardAnimation();
    (<any> window).statsCardsResize = Vue.prototype.$_.debounce(this.statsCardsResize, 1000);
    window.addEventListener("resize", (<any> window).statsCardsResize);
  }

  beforeDestroy() {
    this.controller.destroy(true);
    this.controller = null;

    window.removeEventListener("resize", (<any> window).statsCardsResize);
    (<any> window).statsCardsResize = undefined;
  }

  statsCardsResize(): void {
    // restart the animations on resize
    for (let i = 0; i < this.scenes.length; ++i) {
      this.scenes[i].destroy(true);
    }
    this.scenes = [];
    this.cardAnimation();
  } 

  cardAnimation() {
    // check if horizontal or vertical
    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    
    var isVerticalLayout = Vue.prototype.common.isVerticalLayout();  // check if mobile or not

    // initialize scrollmagic controller
    this.controller = new ScrollMagic.Controller({
      vertical: isVerticalLayout,
    });

    let cards = document.getElementsByClassName("card");
    let cardContainer= <HTMLElement> document.getElementsByClassName("stats-cards-container")[0];
    let cardheight = (<HTMLElement> cards[0])!.clientHeight;
    let cardWidth = (<HTMLElement> cards[0])!.clientWidth;
    let containerHeight = cardContainer!.offsetHeight;
    let containerWidth = cardContainer!.offsetWidth;
    for (let i = 0; i < cards.length; ++i) {
      (<HTMLElement> cards[i]).removeAttribute("style"); // clear inline styles
      let cardPosX = (<HTMLElement> cards[i])!.offsetLeft;
      let cardPosY = (<HTMLElement> cards[i])!.offsetTop;
      var flightPath = {
        tree: {
          curviness: 1.25,

          values: [
            { x: 0, y: 0 },
            //{ x: 0, y: -(-cardheight * 0.6 * i) - (cardheight / 2) },
            { x: (i % 2 === 0) ? (containerWidth * 0.25) : (-containerWidth * 0.25), y: (viewportHeight * 0.8)}
          ]
        }
      };
      var treeTween = TweenMax.to(cards[i], 1, { 
        css: {
          bezier: flightPath.tree,
          autoAlpha: 1
        }, 
        ease: Power1.easeInOut,
        overwrite: true
      });
      if (!isVerticalLayout) {
        // change values for horizontal layout
        flightPath.tree.values = [
          { x: 0, y: 0 },
          { x: 0, y: (-cardheight * 0.6 * i) - (cardheight / 2) },
          { x: (i % 2 === 0) ? (containerWidth * 0.25) : (-containerWidth * 0.25), y: -containerHeight * 0.8 }
        ];
      }
      
      // Getting the width of the element
      let elementWidth = document.getElementById(cards[0].id)!.clientWidth;
      
      // this adds the scenes for the cards moving
      let scene = new ScrollMagic.Scene({
        duration: (isVerticalLayout) ? (viewportHeight * 0.75) : (viewportWidth * 0.75),
        offset: 0,
        triggerHook: "onEnter",
        triggerElement: "#stats-section"
      });
      this.scenes.push(scene);
      this.controller.addScene(
        scene.setTween(treeTween)
      );

      // this adds the scenes for the numbers changing
      let numberScene = new ScrollMagic.Scene({
        duration: 2000,
        reverse: false,
        triggerHook: 0.5,
        triggerElement: "#stats-section"
      })
      .on("enter", () => this.animateValue(cards[i].getElementsByClassName("card-heading")[0], (<HTMLElement> cards[i]).dataset.cardHeading))
      .addTo(this.controller);
    }
  }

  // this method is for the percentages changing
  animateValue(obj:Element, data:string, start = 0, end:any = null, duration = 1500) {
    if (obj) {
      // save starting text for later (and as a fallback text if JS not running and/or google)
      var textStarting = data;
      // remove non-numeric from starting text if not specified
      end = end || parseInt(textStarting.replace(/\D/g, ""));
      var range = end - start;
      // no timer shorter than 50ms (not really visible any way)
      var minTimer = 50;
      // calc step time to show all interediate values
      var stepTime = Math.abs(Math.floor(duration / range));
      // never go below minTimer
      stepTime = Math.max(stepTime, minTimer);
      // get current time and calculate desired end time
      var startTime = new Date().getTime();
      var endTime = startTime + duration;
      var timer:number;
      function run() {
        var now = new Date().getTime();
        var remaining = Math.max((endTime - now) / duration, 0);
        var value = Math.round(end - (remaining * range));
        var text:string = value + "";
        // replace numeric digits only in the original string
        obj.innerHTML = textStarting.replace(/([0-9]+)/g, text);
        if (value == end) {
          clearInterval(timer);
        }
      }
      timer = setInterval(run, stepTime);
      run();
    }
  }
}
